// extracted by mini-css-extract-plugin
module.exports = {"text":"p9N6UuOd0z43rB8o4L3At"};